// Lightweight global trigger for the low-credits popup, decoupled from the React
// tree. Any feature can call triggerLowCreditsModal() (e.g. on a NO_CREDITS API
// error); DashboardLayout listens for the event and shows the modal.
//
// Optional `options.onBuyCredits` runs (awaited) when the user clicks "Buy
// Credits", before navigating to the plans page — e.g. single listing passes a
// save-draft handler so progress isn't lost.
export const LOW_CREDITS_EVENT = 'eb:show-low-credits';

export function triggerLowCreditsModal(options = {}) {
    window.dispatchEvent(new CustomEvent(LOW_CREDITS_EVENT, { detail: options }));
}

// Proactive guard: when `available` is a known number below `required`, show the
// exhausted-credits modal and return false so the caller can bail before hitting the
// API. Returns true otherwise — including when `available` is unknown (null/undefined),
// deferring to the backend's authoritative NO_CREDITS check.
export function hasEnoughCreditsOrPrompt(available, required, options = {}) {
    if (typeof available === 'number' && available < required) {
        triggerLowCreditsModal(options);
        return false;
    }
    return true;
}
